import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

import { FormHeader } from "src/components/EntityForm";
import type { BreadcrumbType } from "src/components/Breadcrumb/Breadcrumbs";

type ProductFormHeaderProps = {
    breadcrumbs: BreadcrumbType[];
    title: string;
    owningCompanyName: string | null;
    onCancel: () => void;
    onSave: () => void;
    saving: boolean;
    saveDisabled?: boolean;
    exitDisabled?: boolean;
};

/** Product compatibility wrapper around the shared entity form header. */
export const ProductFormHeader = forwardRef<HTMLElement, ProductFormHeaderProps>((props, ref) => {
    const {
        breadcrumbs,
        title,
        owningCompanyName,
        onCancel,
        onSave,
        saving,
        saveDisabled = false,
        exitDisabled = false,
    } = props;
    const { t } = useTranslation();

    return (
        <FormHeader
            ref={ref}
            breadcrumbs={breadcrumbs}
            title={title}
            metadata={
                !owningCompanyName ? undefined : (
                    {
                        label: t("product.v2.informations.owning_entity", "Owning entity:"),
                        value: owningCompanyName,
                    }
                )
            }
            onCancel={onCancel}
            onSave={onSave}
            saving={saving}
            cancelDisabled={saving || exitDisabled}
            saveDisabled={saveDisabled}
            testIdPrefix="product-v2"
        />
    );
});

ProductFormHeader.displayName = "ProductFormHeader";
